/* global angular */
( function () {
	'use strict';

	function highlightRedactor ( $document ) {
		function linkFn ( scope, elem ) {
			scope.isOnFocus = false;

			function doSelectAll () {
				return function () {
					scope.isOnFocus = true;
					elem.find( 'textarea' ).redactor( 'selection.all' );
				};
			}

			function clickOutOfElem () {
				scope.isOnFocus = false;
				$document.off( 'click.out' );
			}

			function onClickFn ( event ) {
				event.stopPropagation();
				[ !scope.isOnFocus ].filter( Boolean ).reduce( doSelectAll, angular.noop )();
				$document.on( 'click.out', clickOutOfElem );
			}

			elem.on( 'click', onClickFn );
		}

		return {
			'restrict' : 'A',
			'link'     : linkFn
		};
	}

	highlightRedactor.$inject = [ '$document' ];

	angular
		.module( 'app.components' )
		.directive( 'highlightRedactor', highlightRedactor );
} )();
